export default __webpack_public_path__ + "static/media/share_light.8e7ac7b4.svg";